<template>
  <v-card outlined class="mt-4">
    <v-card-text>
      <v-container class="pa-0">
        <v-row>
          <v-col cols="12" md="3">
            <v-btn color="accent" block @click="saveDialog = true">
              {{ editMode ? "EDITAR" : "GUARDAR" }}&nbsp;
              <v-icon>{{
                editMode ? "mdi-pencil" : "mdi-content-save"
              }}</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <EmailDialogToggle
              :dialog_ref="emailDialog"
              @onOpen="emailDialog = true"
              @onClose="emailDialog = false"
            />
          </v-col>
          <v-col cols="12" md="3">
            <SendByWhatsApp />
          </v-col>
          <v-col cols="12" md="3">
            <CatalogsDialogToggle
              :dialog_ref="catDialog"
              @onOpen="catDialog = true"
              @onClose="catDialog = false"
            />
          </v-col>
          <v-col cols="12" md="3" v-if="editMode == true">
            <v-btn
              color="accent"
              class="ma-auto white--text"
              block
              @click="download"
            >
              <v-icon>mdi-download</v-icon>&nbsp;Descargar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <SaveDialog
      :dialog_ref="saveDialog"
      :editMode="editMode"
      @onConfirm="resetDialog"
      @onCancel="resetDialog"
    />
  </v-card>
</template>

<script>
import SaveDialog from "@/components/Cotizador/SaveDialog.vue";
import EmailDialogToggle from "@/components/Cotizador/EmailDialogToggle.vue";
import SendByWhatsApp from "@/components/Cotizador/SendByWhatsApp.vue";
import CatalogsDialogToggle from "@/components/Cotizador/CatalogsDialogToggle.vue";
import { pdfFromQuotation } from "@/services/pdfGenerator";
export default {
  components: {
    SaveDialog,
    EmailDialogToggle,
    SendByWhatsApp,
    CatalogsDialogToggle,
  },
  props: {
    editMode: Boolean,
  },
  data() {
    return {
      saveDialog: false,
      emailDialog: false,
      catDialog: false,
    };
  },
  computed: {
    email() {
      return this.$store.state.client.email ?? null;
    },
    selectedClient() {
      return this.$store.state.client.selectedClient ?? null;
    },
    phone() {
      return this.$store.state.client.phone ?? null;
    },
    invalid() {
      return this.$store.state.invalid ?? true;
    },
  },
  methods: {
    resetDialog() {
      this.saveDialog = false;
      this.emailDialog = false;
      this.catDialog = false;
    },
    download() {
      pdfFromQuotation(this.$store.state.current);
    },
  },
};
</script>